import React from 'react';

import PropTypes from 'prop-types';

import { ActionsContainer, TextButton } from '../css';

const Actions = ({ mode, setMode }) => {
  return (
    <ActionsContainer>
      <TextButton
        type="button"
        onClick={() => setMode({ ...mode, edit: true })}
      >
        Edit
      </TextButton>
      <span>|</span>
      <TextButton
        type="button"
        onClick={() => setMode({ ...mode, delete: true })}
      >
        Remove
      </TextButton>
    </ActionsContainer>
  );
};

Actions.propTypes = {
  mode: PropTypes.shape({
    edit: PropTypes.bool,
    delete: PropTypes.bool
  }).isRequired,
  setMode: PropTypes.func.isRequired
};

export default Actions;
